import { render, staticRenderFns } from "./BoaruaDataTable.vue?vue&type=template&id=08f053eb&scoped=true"
import script from "./BoaruaDataTable.vue?vue&type=script&lang=js"
export * from "./BoaruaDataTable.vue?vue&type=script&lang=js"
import style0 from "./BoaruaDataTable.vue?vue&type=style&index=0&id=08f053eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f053eb",
  null
  
)

export default component.exports